import { atom as t } from "recoil";
const e = t({ key: "stationModeState", default: !1 });
export {
  e as default
};
